export default "__VITE_ASSET__AQbWpkGV__"